/// @flow
import React, { PureComponent, type Element } from 'react';
import { dynamicClassName } from 'utils/dynamicClassName';

type Props = {
  id: string,
  options: Array<{ label: string, value?: any }>,
  label: string,
  counter?: number,
  inputChanged: (value: string) => void,
  selected: any[],
  className?: string,
  closeOnSelect: boolean,
};

type State = {
  isOpen: boolean,
};

class DropdownMultiInput extends PureComponent<Props, State> {
  props: Props;
  wrapperRef: any;

  static defaultProps = {
    counter: 0,
    closeOnSelect: false,
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  render() {
    const { isOpen } = this.state;
    const { className, selected, label } = this.props;

    let classNames;

    if (className) {
      classNames = dynamicClassName(className);
    } else {
      classNames = dynamicClassName('dropdown dropdown--accordion mb-3');
    }

    isOpen && classNames.add('is-open');
    selected.length > 0 && classNames.add('has-counter');

    return (
      <div className={classNames.build()} ref={this.setWrapperRef}>
        <span
          role="button"
          tabIndex={0}
          className="dropdown__head ft-h6 ft-up"
          onClick={this.handleClickDropDown}
        >
          <span className="dropdown__label">{label}</span>
          <span className="dropdown__counter">({selected.length})</span>
        </span>
        <div className="dropdown__list">
          <span
            role="button"
            tabIndex={0}
            className="dropdown__head ft-h6 ft-up"
            onClick={this.handleClickDropDown}
          >
            <span className="dropdown__label">{label}</span>
            <span className="dropdown__counter">({selected.length})</span>
          </span>
          <div className="dropdown__wrapper">{this.renderOptions()}</div>
        </div>
      </div>
    );
  }

  renderOptions = () => {
    const { options, id, selected } = this.props;

    return options.map<Element<'div' | 'span'>>((option, index) => {
      if (!option.value) {
        return <span key={index}>{option.label}</span>;
      }

      return (
        <div className="checkbox" key={index}>
          <input
            type="checkbox"
            id={id + index}
            onChange={this.handleSelected(option.value)}
            checked={selected.includes(option.value)}
          />
          <label htmlFor={id + index}>
            {option.label}
          </label>
        </div>
      );
    });
  };

  handleClickDropDown = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  };

  setWrapperRef = (node: any) => {
    this.wrapperRef = node;
  };

  handleClickOutside = (event: MouseEvent) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  };

  handleSelected = (value: string) => {
    const { inputChanged, closeOnSelect } = this.props;

    return () => {
      if(closeOnSelect) {
        this.setState(prevState => ({
          isOpen: false
        }));
      }
      inputChanged(value);
    };
  };
}

export default DropdownMultiInput;
